import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { PosCashierModel } from './PosModels';
import type { APIResponse } from '../../Shared/shared';

 
export const addPosCashers = createAsyncThunk(
  'PosCashier/addPosCashers',
  async (item: PosCashierModel, { rejectWithValue, dispatch, getState }) => {
    try {
      const state: any = getState();
      const posCashersList = state?.PosCashier?.PosCashierListByPosId; // تأكد أن المسار إلى القائمة صحيح
      // التحقق من وجود الكاشير في القائمة باستخدام personId
      const existingCashier = posCashersList.find((cashier: PosCashierModel) => cashier.personId === item.personId);

      if (existingCashier) {
        // إرجاع رسالة في حالة وجود الكاشير مسبقًا
        return rejectWithValue('The cashier with the given personId already exists.');
      }

      const { data } = await ntxAPI.post<APIResponse<PosCashierModel>>('Pos/AddPosCashers', item);

      if (data.succeeded) {
        // تأكد من انتظار تحديث الكاشيرات بعد الإضافة
        await dispatch(GetPosCashersByPosId(item.posId));
        return data;
      } else {
        // في حالة فشل الـ API إعادة رسالة الخطأ
        return rejectWithValue(data.message || 'An unknown error occurred.');
      }
    } catch (error: any) {
      // معالجة الاستثناءات العامة
      const errorMessage =
        error.response?.data?.message || error.message || 'An error occurred while adding the cashier.';
      return rejectWithValue(errorMessage);
    }
  }
);

export const updatePosCashers = createAsyncThunk(
  'PosCashier/updatePosCashers',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
       const { data } = await ntxAPI.post<APIResponse<boolean>>('Pos/UpdatePosCashers', item);

      if (data.succeeded) {
        await dispatch(GetPosCashersByPosId(item.posId));
        return data;
      } else {
        return rejectWithValue(data.message || 'An unknown error occurred.');
      }
    } catch (error: any) {
      // معالجة الاستثناءات العامة
      const errorMessage =
        error.response?.data?.message || error.message || 'An error occurred while adding the cashier.';
      return rejectWithValue(errorMessage);
    }
  }
);

export const getPosCashersList = createAsyncThunk('PosCashier/GetPosCashersList', async (_, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.get<APIResponse<PosCashierModel[]>>('Pos/GetPosCashersList');
    if (data.succeeded) {
      return data.data;
    } else {
      return rejectWithValue(data.message);
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const GetPosCashersByPosId = createAsyncThunk(
  'PosCashier/GetPosCashersByPosId',
  async (posId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<PosCashierModel[]>>(`Pos/GetPosCashersByPosId?PosId=${posId}`);
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletePosCashers = createAsyncThunk(
  'PosCashier/deletePosCashers',
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(`Pos/DeletePosCashers?Id=${id}`);
      if (data.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


export const activePosCashers = createAsyncThunk(
  'PosCashier/activePosCashers',
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(`Pos/ActivePosCashers?Id=${id}`);
      if (data.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);









const initialState = {
  PosCashierList: [] as PosCashierModel[],
  PosCashierListByPosId: [] as PosCashierModel[],
  PosCashierById: {} as PosCashierModel,
  loading: false,
  error: null as string | null
};

// const initialState: {
//   PosCashierList: PosCashierModel[];
//   PosCashierListByPosId: PosCashierModel[];
//   PosCashierById: PosCashierModel;
//   loading: boolean;
//   error: any | null;
// } = {
//   PosCashierList: [],
//   PosCashierListByPosId: [],
//   PosCashierById: {} as PosCashierModel,
//   loading: false,
//   error: null,
// };

const PosCashierSlice = createSlice({
  name: 'PosCashier',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPosCashersList.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPosCashersList.fulfilled, (state, action: PayloadAction<PosCashierModel[]>) => {
        state.loading = false;
        state.PosCashierList = action.payload;
      })
      .addCase(getPosCashersList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(GetPosCashersByPosId.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetPosCashersByPosId.fulfilled, (state, action: PayloadAction<PosCashierModel[]>) => {
        state.loading = false;
        state.PosCashierListByPosId = action.payload;
      })
      .addCase(GetPosCashersByPosId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deletePosCashers.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePosCashers.fulfilled, (state, action: PayloadAction<APIResponse<boolean>>) => {
        state.loading = false;
        // state.PosCashierList = state.PosCashierList?.filter(cashier => cashier.id !== action.payload);
      })
      .addCase(deletePosCashers.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    // .addCase(addPosCashers.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // })
    // .addCase(
    //   addPosCashers.fulfilled,
    //   (state, action: PayloadAction<APIResponse<PosCashierModel>>) => {
    //     state.loading = false;
    //     state.PosCashierList.push(action.payload.data);
    //   }
    // )
    // .addCase(addPosCashers.rejected, (state, action: PayloadAction<any>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });
  }
});

export default PosCashierSlice.reducer;
